// extracted by mini-css-extract-plugin
export default {"map":"Incidents_map__lHEXi","mapHolder":"Incidents_mapHolder__ITa9s"};